import request from "@/utils/request";

/*=======================教师均衡发展驾驶舱========================*/
// 教师概况
export const  areaTeacherData =(query) =>{
    return request({
        url: "/businessservice/areaDashboard/teacher/teaData",
        method:"get",
        params: query
    })
}

// 查询教师年龄结构分布
export const  areaTeacherAge =(data) =>{
    return request({
        url: "/businessservice/areaDashboard/teacher/teaAge",
        method:"post",
        data: data
    })
}

// 查询教师学科分布
export const  areaTeacherSubject =(data) =>{
    return request({
        url: "/businessservice/areaDashboard/teacher/teaSubject",
        method:"post",
        data: data
    })
}

// 查询新老教师学科分布
export const  areaTeacherAgeSubject =(data) =>{
    return request({
        url: "/businessservice/areaDashboard/teacher/teaTeachAgeSubject",
        method:"post",
        data: data
    })
}

// 查询教师教龄分布
export const  areaTeacherTeachAge =(data) =>{
    return request({
        url: "/businessservice/areaDashboard/teacher/teaTeachAge",
        method:"post",
        data: data
    })
}

/*=======================课堂研究========================*/
// 课堂研究概况
export const  areaEvaData =(query) =>{
    return request({
        url: "/businessservice/areaDashboard/eva/data",
        method:"get",
        params: query
    })
}

// 听评课学科分布
export const  areaEvaSubject =(data) =>{
    return request({
        url: "/businessservice/areaDashboard/eva/lessonSubject",
        method:"post",
        data: data
    })
}

// 听评课人数分布
export const  areaEvaNumData =(data) =>{
    return request({
        url: "/businessservice/areaDashboard/eva/lessonNum",
        method:"post",
        data: data
    })
}

// 听评课年龄分布
export const  areaEvaAgeData =(data) =>{
    return request({
        url: "/businessservice/areaDashboard/eva/lessonAge",
        method:"post",
        data: data
    })
}

// 听评课时间分布
export const  areaEvaYearData =(data) =>{
    return request({
        url: "/businessservice/areaDashboard/eva/lessonYear",
        method:"post",
        data: data
    })
}

// 听评课学科年龄分布
export const  areaEvaTeachAgeData =(data) =>{
    return request({
        url: "/businessservice/areaDashboard/eva/lessonTeachAge",
        method:"post",
        data: data
    })
}

// 听评课学科年龄分布
export const  areaEvaTypeData =(data) =>{
    return request({
        url: "/businessservice/areaDashboard/eva/lessonType",
        method:"post",
        data: data
    })
}